module.exports = __webpack_public_path__ + "img/black-naira.2237100a.svg";